import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  console.log(STORE_KEY, INITIAL_STATE)
  const appState = state || redux.store.getState();
  console.log(appState?.[STORE_KEY] || INITIAL_STATE)
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectLocationData = state => selectState(state).data;
export const selectedLocation = state => selectState(state).location;
export const getPrinters = state => selectState(state).printersdata;
export const selectLocationLoading = state => selectState(state).loading;
export const selectfetchLocationLoading = state => selectState(state).locationLoading;
export const selectLocationError = state => selectState(state).error;
export const selectLocationFilterVisible = state => selectState(state).filterVisible;
export const selectLocationFilters = state => selectState(state).filters;
export const selectFilterVisible = state => selectState(state).filterVisible;
export const selectTileView = state => selectState(state).tileView;
export const selectFilteredLocations = createSelector(
  [selectLocationData, selectLocationFilters],
  (data, { searchText }) => {
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      ),
    );
  },
);


